<template>
	<v-container :class="{'pa-0': $vuetify.breakpoint.smAndDown, 'px-5 py-0': $vuetify.breakpoint.mdAndUp}">
		<v-layout row wrap>
			<v-flex md6 sm6 xs12 :class="{'px-0': $vuetify.breakpoint.smAndDown, 'px-3': $vuetify.breakpoint.mdAndUp}">
				<v-layout row wrap>
					<v-flex xs12 px-0 class="search-element-container" ref="searchContainer" :style="{height: searchContainerHeight + 64 +'px'}">
						<v-text-field
			        class="mx-0 barra-busqueda"
			        flat
			        label="Buscar elemento"
			        background-color="#1f97b9"
			        height="64px"
			        dark
			        color="white"
			        solo-inverted
			        hide-details
			        v-model="searchInput"
			        @keyup="searchedElement"
			      >
			      	<img :src='require("../../../assets/static/img/search.png")' alt="imagen de busqueda" style="width: 30px;height:30px;" slot="prepend-inner">
			      </v-text-field>
            <v-btn class="btn-close-pago-dialog" dark icon v-show="showSearch" @click="showSearch = false">
              <v-img :src='require("../../../assets/static/img/cerrar.png")' alt="imagen de cierre de ventana" max-height="25" contain></v-img>
            </v-btn>
						<v-list two-line id="list-suggestions" class="list-suggestion" v-show="showSearch" ref="searchResultContainer">
		          <template v-for="(item, index) in searchElements">
		            <v-list-tile
		              :key="'sf-' + index"
		              ripple
		            >
									<v-list-tile-content class="title-elements-list-title">
										<v-img
											:src='item.img'
											max-height="40"
											max-width="40"
											class="mr-2"
											contain
										></v-img>
										<v-list-tile-title style="height:auto;line-height: 15px;">
											<small>{{ item.cat }}</small><br/>
											{{ item.nombre }}
										</v-list-tile-title>
										<v-tooltip right max-width="300px">
												<template slot="activator">
													<v-layout align-center>
														<img
															:src='require("../../../assets/static/img/info.png")'
															alt="imagen de informacion"
															class="ml-2"
															width="16px"
															height="16px"
															contain
														/>
													</v-layout>
												</template>
								        <span>{{item.descripcion}}</span>
								    </v-tooltip>
									</v-list-tile-content>

		              <v-list-tile-action class="actions-element-search">
<!-- 										<v-layout align-center>
											<v-text-field
												v-if="showSearch"
												:ref="'s-' + index"
												color="#1f97b9"
												class="input-qty-second"
												type="number"
												style="width: 30px;"
												@input="addElementbySearch('s-' + index)"
												:min="0"
											></v-text-field>
										</v-layout> -->
										<v-btn color="#1f97b9" style="max-width:30px;max-height:30px;" fab small dark @click="minusElementbySearch('s-' + index)">
											<v-icon small>fas fa-minus</v-icon>
										</v-btn>
										<p v-if="showSearch" :ref="'s-' + index" class="qty-input-select-element">0</p>
										<v-btn color="#1f97b9" style="max-width:30px;max-height:30px;" fab small dark @click="plusElementbySearch('s-' + index)">
											<v-icon small>fas fa-plus</v-icon>
										</v-btn>
		              </v-list-tile-action>

		            </v-list-tile>
		            <v-divider
		              v-if="index + 1 < searchElements.length"
		              :key="'div-' + index"
		            ></v-divider>
		          </template>
		        </v-list>

					</v-flex>
				</v-layout>
				<v-expansion-panel>
					<v-expansion-panel-content
						v-for="(el, i) in elementos"
						style="background-color: #1f97b9;"
						:key="i"
						class="custom-expansion-panel-td mb-1"
						hide-actions
					>
						<div slot="header">
							<v-layout row wrap align-center class="background-duo">
								<v-flex md2 sm2 xs2 py-1 align-center justify-center class="text-xs-center container-nombre-categoria">
									<h3 class="font-weight-bold white--text nombre-categoria">{{ el.datos.nombre }}</h3>
								</v-flex>
								<v-flex md10 sm10 xs10 align-center justify-center class="icon-nombre-categoria">
									<v-img
										class="link mx-auto my-3 img-icon-categoria"
										:src='el.datos.img'
										max-height="80"
										contain
									></v-img>
								</v-flex>
							</v-layout>
						</div>
						<v-icon slot="actions" color="white" class="mr-3">fas fa-caret-down</v-icon>
						<v-card>
							<v-card-text class="grey lighten-3" style="color: black">
								<v-list class="grey lighten-3 listado-elementos elements-second" style="color: black;" dense>
									<v-list-tile
										v-for="(els, index) in el.elementos"
										:class="{'grey lighten-2' : index % 2 !== 0}"
										:key="index"
									>
										<v-list-tile-content class="title-elements-list-title">
											<v-img
												:src='els.img'
												max-height="40"
												max-width="40"
												class="mr-2"
												contain
											></v-img>
											<v-list-tile-title v-text="els.nombre"></v-list-tile-title>
											<v-tooltip right max-width="300px">
													<template slot="activator">
														<v-layout align-center>
															<img
																:src='require("../../../assets/static/img/info.png")'
																alt="imagen de informacio"
																class="ml-2"
																width="16px"
																height="16px"
																contain
															/>
														</v-layout>
													</template>
									        <span>{{els.descripcion}}</span>
									    </v-tooltip>
										</v-list-tile-content>

										<v-list-tile-action class="elements-actions-second">
											<v-layout align-center>
<!-- 												<v-text-field
													:ref="i + '-' + index"
													color="#1f97b9"
													class="input-qty-second"
													type="number"
													style="width: 30px;"
													@input="addElement(i + '-' + index)"
													:min="0"
												></v-text-field> -->
												<v-btn color="#1f97b9" style="max-width:30px;max-height:30px;" fab small dark @click="minusElement(i + '-' + index)">
													<v-icon small>fas fa-minus</v-icon>
												</v-btn>
												<p :ref="i + '-' + index" class="qty-input-select-element">0</p>
												<v-btn color="#1f97b9" style="max-width:30px;max-height:30px;" fab small dark @click="plusElement(i + '-' + index)">
													<v-icon small>fas fa-plus</v-icon>
												</v-btn>
											</v-layout>
										</v-list-tile-action>

									</v-list-tile>
								</v-list>
							</v-card-text>
						</v-card>
					</v-expansion-panel-content>					
				</v-expansion-panel>
				<h4 class="text-duo">¿QUÉ NECESITA TRASLADAR?</h4>
        <v-textarea
          name="observaciones"
          placeholder="Por favor ingrese aquí sus preguntas u observaciones y nos pondremos en contacto a la brevedad con usted."
          solo
          class="mt-2"
          v-model="observaciones"
        ></v-textarea>
				<v-layout row wrap align-center class="background-duo">
					<v-flex md12 sm12 xs12 align-center justify-center class="text-xs-center">
						<div v-if="element_manual.manual">
							<v-layout row wrap align-center class="background-duo">
								<v-flex md2 sm2 xs2 py-1 align-center justify-center class="text-xs-center container-nombre-categoria">
									<h3 class="font-weight-bold white--text nombre-categoria">{{element_manual.datos.nombre}}</h3>
								</v-flex>
								<v-flex md10 sm10 xs10 align-center justify-center class="icon-nombre-categoria">
									<v-img
										class="link mx-auto my-3 img-icon-categoria"
										:src='element_manual.datos.img'
										max-height="80"
										contain
									></v-img>
								</v-flex>
							</v-layout>
						</div>
						<v-card v-if="element_manual.manual">
							<v-card-text class="grey lighten-3" style="color: black">
								<v-form ref="formManual">
									<v-layout row wrap align-center>
										<v-flex md12 sm12 xs12 py-1 px-2 align-center>
											<h4>Por favor ingresa los datos del artículo</h4>
										</v-flex>
										<v-flex md12 sm12 xs12 align-center>
											<v-layout row wrap align-center>
												<v-flex md5 sm5 xs5 py-1 px-2 align-center>
													<img
														:src='require("../../../assets/static/img/cubo2.png")'
														alt="instrucciones de medicion"
														class="ml-2"
														width="100%"
														contain
													/>
												</v-flex>
												<v-flex md7 sm7 xs7 py-1 px-2 align-center>
													<v-text-field
														label="Descripción"
														v-model="manualElement.descripcion"
														color="#1f97b9"
														:rules="rules.required"
													></v-text-field>
													<v-text-field
														label="Alto (cm)"
														v-model="manualElement.alto"
														color="#1f97b9"
														type="number"
														:step="1"
														:min="1"
													></v-text-field>
													<v-text-field
														label="Ancho (cm)"
														v-model="manualElement.ancho"
														color="#1f97b9"
														type="number"
														:step="1"
														:min="1"
													></v-text-field>
													<v-text-field
														label="Largo (cm)"
														v-model="manualElement.largo"
														color="#1f97b9"
														type="number"
														:step="1"
														:min="1"
													></v-text-field>
													<v-text-field
														label="Peso (kg)"
														v-model="manualElement.peso"
														color="#1f97b9"
														type="number"
														:step="0.1"
														:min="0.1"
													></v-text-field>
													<v-text-field
														label="Cantidad"
														v-model="manualElement.qty"
														color="#1f97b9"
														type="number"
														:min="1"
														:rules="rules.required"
													></v-text-field>
													<v-text-field
														label="Valor Comercial"
														v-model="manualElement.valor_comercial"
														color="#1f97b9"
														type="number"
														:min="1"
														:rules="rules.required"
													></v-text-field>
												</v-flex>
											</v-layout>
										</v-flex>
										<v-flex md12 sm12 xs12 align-center>
											<v-flex md12 sm12 xs12 py-1 px-2 align-center>
												<v-btn
													color="#1f97b9"
													@click="addManual"
													dark
													block
												>
													Agregar Artículo
												</v-btn>												
											</v-flex>
										</v-flex>
									</v-layout>
								</v-form>
							</v-card-text>
						</v-card>
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex md6 sm6 xs12 :class="{'px-0': $vuetify.breakpoint.smAndDown, 'px-3': $vuetify.breakpoint.mdAndUp}">

				<v-toolbar color="#1f97b9" dark v-in-viewport class="item-qty-container">
					<img :src='require("../../../assets/static/img/clipboard.png")' alt="icono de informacion" style="width: 30px;">
					<v-toolbar-title class="texto-listado-articulos-sel">Artículos a Transportar <span>{{totalElements}}</span></v-toolbar-title>
					<span>{{counterVolume}}</span>
				</v-toolbar>
				<v-card>
					<v-card-text class="grey lighten-3" style="color: black">
						<v-list class="grey lighten-3 listado-elementos" style="color: black;" dense>
							<v-list-tile
								v-for="(els, index) in selectedElements"
								:class="{'grey lighten-2' : index % 2 !== 0}"
								:key="index"
							>
								<v-list-tile-avatar>
									<v-badge color="#1f97b9">
										<span slot="badge">{{els.qty}}</span>
									</v-badge>
								</v-list-tile-avatar>
								<v-list-tile-content class="title-elements-list-title">
									<v-img
										:src='els.img'
										max-height="40"
										max-width="40"
										class="mr-2"
										contain
									></v-img>
									<v-list-tile-title v-text="els.nombre"></v-list-tile-title>
								</v-list-tile-content>
								<v-list-tile-action>
									<v-btn style="max-width:30px;max-height:30px;" color="#1f97b9" fab small dark @click="removeElement(index)">
										<v-icon small>fas fa-minus</v-icon>
									</v-btn>
								</v-list-tile-action>
							</v-list-tile>
						</v-list>
					</v-card-text>
				</v-card>

			</v-flex>
		</v-layout>

		<v-layout justify-end>
			<v-btn
				color="grey"
				dark
				@click="goBack"
			>
				Volver
			</v-btn>
			<v-btn
				color="#1f97b9"
				@click="validate"
				dark
			>
				Cotizar
			</v-btn>
		</v-layout>
	</v-container>
</template>

<script>
	import { EventBus } from '../../../events.js'
	import * as firebase from 'firebase/app'
	import 'firebase/firestore'
	export default {
		name: 'mudanzaSecond',
		data () {
			return {
				elementos: [],
				observaciones: '',
				manualElement: {},
				element_manual: {},
				totalSearchElements: [],
				searchElements: [],
				searchInput: '',
				showSearch: false,
				selectedElements: [],
				totalElements: 0,
				datos:{},
				counterVolume: 0,
				searchContainerHeight: 0,
				rules: {
					required: [ v => !!v || 'Campo obligatorio' ]
				}
			}
		},
		methods: {
			searchedElement(){
				const self = this
				console.log(this.totalSearchElements)
				this.searchElements = this.totalSearchElements.filter(function(el){
					if(
						el.nombre.toLowerCase().search(self.searchInput.toLowerCase()) !== -1 ||
						el.descripcion.toLowerCase().search(self.searchInput.toLowerCase()) !== -1
					){
						return true
					}
					else{return false}
				})
				if(this.searchInput.length > 2){
					this.showSearch = true
				}
				else{ this.showSearch = false }
			},
			plusElement(el){
				let qty = parseInt(this.$refs[el][0].innerText)
				qty++
				this.$refs[el][0].innerText = qty
				if(qty || qty == ''){
					let indexes = el.split("-")
					let newElement = { qty: parseInt( qty ), escaleraO: false, escaleraD: false }
					let newObjectElement = Object.assign( newElement, this.elementos[indexes[0]].elementos[indexes[1]] )

					var foundIndex = this.selectedElements.findIndex(x => x.nombre == newObjectElement.nombre)
					if(foundIndex != -1){
						this.selectedElements[foundIndex].qty = newObjectElement.qty
						if(newObjectElement.qty == 0){
							this.selectedElements.splice(foundIndex,1)
						}
					}
					else{
						this.selectedElements.push(newObjectElement)
					}
					this.countElements()
				}
			},
			minusElement(el){
				let qty = parseInt(this.$refs[el][0].innerText)
				if(qty > 0){
					qty--
					this.$refs[el][0].innerText = qty
					if(qty || qty == ''){
						let indexes = el.split("-")
						let newElement = { qty: parseInt( qty ), escaleraO: false, escaleraD: false }
						let newObjectElement = Object.assign( newElement, this.elementos[indexes[0]].elementos[indexes[1]] )

						var foundIndex = this.selectedElements.findIndex(x => x.nombre == newObjectElement.nombre)
						if(foundIndex != -1){
							this.selectedElements[foundIndex].qty = newObjectElement.qty
							if(newObjectElement.qty == 0){
								this.selectedElements.splice(foundIndex,1)
							}
						}
						else{
							this.selectedElements.push(newObjectElement)
						}
						this.countElements()
					}
				}
			},
			plusElementbySearch(el){
				let qty = parseInt(this.$refs[el][0].innerText)
				qty++
				this.$refs[el][0].innerText = qty
				if(qty || qty == ''){
					let indexes = el.split("-")
					let newElement = { qty: parseInt( qty ), escaleraO: false, escaleraD: false }
					let newObjectElement = Object.assign( newElement, this.searchElements[indexes[1]] )

					var foundIndex = this.selectedElements.findIndex(x => x.nombre == newObjectElement.nombre)
					if(foundIndex != -1){
						this.selectedElements[foundIndex].qty = newObjectElement.qty
						if(newObjectElement.qty == 0){
							this.selectedElements.splice(foundIndex,1)
						}
					}
					else{
						this.selectedElements.push(newObjectElement)
					}
					this.countElements()
				}
			},
			minusElementbySearch(el){
				let qty = parseInt(this.$refs[el][0].innerText)
				if(qty > 0){
					qty--
					this.$refs[el][0].innerText = qty
					if(qty || qty == ''){
						let indexes = el.split("-")
						let newElement = { qty: parseInt( qty ), escaleraO: false, escaleraD: false }
						let newObjectElement = Object.assign( newElement, this.searchElements[indexes[1]] )

						var foundIndex = this.selectedElements.findIndex(x => x.nombre == newObjectElement.nombre)
						if(foundIndex != -1){
							this.selectedElements[foundIndex].qty = newObjectElement.qty
							if(newObjectElement.qty == 0){
								this.selectedElements.splice(foundIndex,1)
							}
						}
						else{
							this.selectedElements.push(newObjectElement)
						}
						this.countElements()
					}
				}
			},
			addElement(el){
				console.log(this.$refs[el][0])
				let qty = this.$refs[el][0].$refs.input.value
				if(qty == ''){qty = 0}
				if(qty || qty == ''){
					let indexes = el.split("-")
					let newElement = { qty: parseInt( qty ), escaleraO: false, escaleraD: false }
					let newObjectElement = Object.assign( newElement, this.elementos[indexes[0]].elementos[indexes[1]] )

					var foundIndex = this.selectedElements.findIndex(x => x.nombre == newObjectElement.nombre)
					if(foundIndex != -1){
						this.selectedElements[foundIndex].qty = newObjectElement.qty
						if(newObjectElement.qty == 0){
							this.selectedElements.splice(foundIndex,1)
						}
					}
					else{
						this.selectedElements.push(newObjectElement)
					}
					this.countElements()
				}
			},
			addElementbySearch(el){
				let qty = this.$refs[el][0].$refs.input.value
				if(qty == ''){qty = 0}
				if(qty || qty == ''){
					let indexes = el.split("-")
					let newElement = { qty: parseInt( qty ), escaleraO: false, escaleraD: false }
					let newObjectElement = Object.assign( newElement, {nombre: this.searchElements[indexes[1]].nombre, metros: this.searchElements[indexes[1]].metros})

					var foundIndex = this.selectedElements.findIndex(x => x.nombre == newObjectElement.nombre)
					if(foundIndex != -1){
						this.selectedElements[foundIndex].qty = newObjectElement.qty
						if(newObjectElement.qty == 0){
							this.selectedElements.splice(foundIndex,1)
						}
					}
					else{
						this.selectedElements.push(newObjectElement)
					}
					this.countElements()
				}
			},
			addManual(){
				if(this.$refs.formManual.validate()){
					const volume = this.manualElement.alto * this.manualElement.ancho * this.manualElement.largo * 0.000001
					const newObjectElement = {
						cat: "Manual",
						escarleraO: false,
						escarleraD: false,
						metros: volume,
						nombre: this.manualElement.descripcion,
						qty: parseInt(this.manualElement.qty),
						img: 'https://firebasestorage.googleapis.com/v0/b/duoapp-56ef2.appspot.com/o/elements_flete_img%2Forder.png?alt=media&token=3b73466c-07ae-456c-a652-08c8ba6b83b6',
						valor_comercial: parseInt(this.manualElement.valor_comercial)
					}
					this.selectedElements.push(newObjectElement)
					this.countElements()
					this.$refs.formManual.reset()
					window.scrollTo(0,0)
				}
			},
			removeElement(index){
				this.selectedElements.splice(index,1)
				this.countElements()
			},
			countElements(){
				const here = this
				let counter = 0
				let counterVolume = 0
				this.selectedElements.map(function(item) {
					 counter = counter + item.qty
					 counterVolume = counterVolume + (item.qty*item.metros)
					 counterVolume = Math.round(counterVolume * 100) / 100
				});
				this.counterVolume = counterVolume
				this.totalElements = counter
			},
			goBack(){
				EventBus.$emit('goBackFlete', 2)
			},
			validate () {
				var data = {
					datos: this.selectedElements,
					qty: this.totalElements,
					observaciones: this.observaciones,
					valid: true
				}
				if (this.selectedElements.length > 0) {
					EventBus.$emit('fleteSecond', data);
				}
				else{
					data.valid = false
					EventBus.$emit('fleteSecond', data);
					this.control = false
				}
			}

		},
		watch: {
			searchElements: function(){
				const here = this
	      this.$nextTick(() => {
          here.searchContainerHeight = here.$refs.searchResultContainer.$el.clientHeight
	      });
			},
			showSearch: function(val){
				if(!val){ this.searchContainerHeight = 0 }
			}
		},
		mounted () {			
			let db = firebase.firestore()
			let self = this
			db.collection("elementos_flete").get().then((querySnapshot) => {
				querySnapshot.forEach((doc) => {
					const elementos = doc.data()
					if(!elementos.manual){
						self.elementos.push( elementos )
						elementos.elementos.forEach((elemento) => {
							let data = elemento
							data.cat = elementos.datos.nombre
							self.totalSearchElements.push( data )
						})
					}
					else{
						self.element_manual = doc.data()
					}
				})
				self.elementos.sort(function(a, b) {
					if (a.datos.posicion > b.datos.posicion) {
						return 1;
					}
					if (a.datos.posicion < b.datos.posicion) {
						return -1;
					}
					return 0;
				})
			})

			EventBus.$on('validateBeforeThirdFlete', data => {
				this.validate()
			})
		}
	}
</script>